export default {
  title: 'Brändit',
  form: {
    name: {
      placeholder: 'Hae brändiä...',
    },
  },
  fields: {
    id: '#',
    name: 'Nimi',
    address: 'Osoite',
    subdomain: 'Aliverkkotunnus',
    shop_url: 'Myymälän URL',
    companies: 'Yritykset',
    slug: 'Tunniste',
    actions: '',
  },
  empty_list: 'Ei vielä brändejä',
  modals: {
    delete_franchise: {
      title: 'Haluatko varmasti poistaa brändin {{name}}?',
    },
  },
  buttons: {
    new_franchise: '+ Lisää brändi',
    export_restaurants: 'Vie ravintolat',
    edit: 'Muokkaa',
    delete: 'Poista',
    view_dashboard_as_owner: 'Näytä hallintapaneeli omistajana',
    open_shop: 'Avaa myymälä',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    failed_to_delete_franchise: 'Brändin poistaminen epäonnistui',
    franchise_got_deleted: 'Brändi poistettu',
    failed_to_create_magic_link: 'Taikalinkin luominen epäonnistui',
    no_owner_to_log_in_as: 'Ei ravintolan omistajaa, jona kirjautua sisään',
  },
};
